import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { Holdeo } from '@shared/models/facturacion/Holdeo';
import { MessageService } from '@shell/message.service';
import { ComprobanteService } from '../../comprobante.service';
import { NuevoHoldeoComponent } from '../nuevo-holdeo/nuevo-holdeo.component';
import { TipoHoldeo } from '@shared/enums/TipoHoldeo';

@Component({
  selector: 'app-holdeo-aeroplanta',
  templateUrl: './holdeo-aeroplanta.component.html',
  styleUrls: ['./holdeo-aeroplanta.component.css']
})
export class HoldeoAeroplantaComponent implements OnInit {
  @Output() volver = new EventEmitter();

  desactivandoHoldeo: boolean = false;

  cuentasHoldeadas: Holdeo[] = [];
  obteniendo: boolean = false;
  holdeoSeleccionado: number;
  constructor(private spinner: NgxSpinnerService, private comprobantesService: ComprobanteService, private modal: NgbModal,
    private messageService: MessageService) { }

  ngOnInit() {
    this.getHoldeoCuenta();
  }

  getHoldeoCuenta() {
    this.spinner.show('spinnerLista');
    this.obteniendo = true;
    this.comprobantesService.getHoldeo(4, TipoHoldeo.TodaFacturacion)
      .subscribe(result => {
        this.cuentasHoldeadas = result;
        this.spinner.hide('spinnerLista');
        this.obteniendo = false;
      });
  }

  agregarAeroplanta(){
    const modalRef = this.modal.open(NuevoHoldeoComponent, {centered: true, backdrop: 'static'});
    modalRef.componentInstance.tipo = 0;
    modalRef.result.then(result => {
      result == true ? this.ngOnInit() : null
    });
  }

  quitarHoldeo(i: number){
    this.desactivandoHoldeo = true;
    this.holdeoSeleccionado = i;
    this.cuentasHoldeadas[i].activo = !this.cuentasHoldeadas[i].activo;
    this.comprobantesService.putHoldeo(this.cuentasHoldeadas[i])
      .subscribe(result => {
        this.messageService.showSuccessMessage(`El holdeo General fue ${result.activo ? 'activado' : 'desactivado'} con éxito`);
        this.getHoldeoCuenta();
        this.desactivandoHoldeo = false;
        this.holdeoSeleccionado = null;
      }, () => {
        this.messageService.showErrorMessage('Hubo un error al actualizar el estado del holdeo General');
        this.desactivandoHoldeo = false;
        this.holdeoSeleccionado = null;
      });
  }

  goBack(){
    this.volver.emit(true);
  }

}
